export const widgetContextChanged = (key, value) => {
  const ref = document.querySelector(".msem-widget-root");
  if (!ref) return;
  const event = new CustomEvent("widgetContextChanged", { detail: { [key]: value }, bubbles: true });
  ref.dispatchEvent(event);
};
